import React from 'react';

import { Button } from '@rio-cloud/rio-uikit';
import { FooterActionsProps } from '../types';

const FooterActions: React.FC<FooterActionsProps> = ({
  onCancel,
  onSubmit,
  isSubmitDisabled
}) => (
  <div className="margin-top-20 display-flex gap-10 justify-content-end flex-grow">
    <Button bsSize={Button.MD} style={{ width: 84 }} onClick={onCancel}>
      Voltar
    </Button>
    <Button
      disabled={isSubmitDisabled}
      bsStyle={Button.PRIMARY}
      bsSize={Button.MD}
      onClick={onSubmit}
    >
      Avançar
    </Button>
  </div>
);

export default FooterActions; 